import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'msd-image-preview-cell',
  templateUrl: './image-preview-cell.component.html',
  styleUrls: ['./image-preview-cell.component.scss'],
})
export class ImagePreviewCellComponent implements OnInit {
  @Input() canBeRemoved = false;
  @Input() src: string;
  @Output() remove = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}
}
